import React from 'react';
import { getImageUrl } from '../../utils/GlobalAPI';

const LivePreview = ({ image, title, subtext }) => {
  return (
    <div className="relative w-full h-64 md:h-80 rounded-xl overflow-hidden border-2 border-gray-300 shadow-lg">
      {/* Background Image */}
      {image && (
        <img
          src={getImageUrl(image)}
          alt="Preview"
          className="absolute inset-0 w-full h-full object-cover"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      )}
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-midnight-50/95 via-midnight-100/90 to-midnight-50/95" />
      <div className="absolute inset-0 bg-gradient-to-br from-neon-purple/10 via-neon-orange/5 via-neon-pink/10 to-neon-cyan/5" />
      
      {/* Content Preview */}
      <div className="absolute inset-0 flex items-center justify-center p-6 z-10">
        <div className="text-center max-w-2xl">
          {title && (
            <h3 className="text-2xl md:text-3xl font-bold mb-3 drop-shadow-lg">
              {title.split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {line.split('**').map((part, j) => {
                    if (j % 2 === 1) {
                      return <span key={j} className="bg-gradient-to-r from-neon-purple via-neon-orange to-neon-pink bg-clip-text text-transparent">{part}</span>;
                    }
                    return <span key={j} className="text-white">{part}</span>;
                  })}
                  {i < title.split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </h3>
          )}
          {subtext && (
            <p className="text-sm md:text-base text-white/90 drop-shadow-md">
              {subtext}
            </p>
          )}
        </div>
      </div>
      
      {/* Preview Label */}
      <div className="absolute top-2 left-2 bg-black/50 backdrop-blur-sm text-white text-xs px-2 py-1 rounded">
        Live Preview
      </div>
    </div>
  );
};

export default LivePreview;

